// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { browserSessionStorage } from '@/utils/sessionStorage';

export const SUPABASE_URL = "https://ifdgfluvnimwasqkutjg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlmZGdmbHV2bmltd2FzcWt1dGpnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMzMjI2MTQsImV4cCI6MjA2ODg5ODYxNH0.UmOPP9yEWkIrxwKIBt4i2xIeZ2sYjepdCJhaBosjQmA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

const sessionStorageConfig=browserSessionStorage();
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  global: { fetch: (input, init) => globalThis.fetch(input, init) },
  auth: {
    ...sessionStorageConfig,
    persistSession: true,
    autoRefreshToken: true,
  }
});

export { SUPABASE_PUBLISHABLE_KEY };
